import { gql } from "@apollo/client";

export const CATEGORY_VENDOR_COUNT_QUERY = gql`
  query vendorCount($categoryIds: [Identifier]) {
    vendor(category_ids: $categoryIds) {
      data {
        id
      }
      count
    }
  }
`;
